import React, { useEffect, useState } from 'react';
import MultiSelect from 'react-multi-select-component';

const FacetGroup = ({ facet, title, keyName, handleParams, params }) => {

	const defaultValue = []

	const availableKeys = ( f ) => {
		// get all available options
		return f.buckets.map( (filter) => {
			return filter.key
		})
	}

	const allKeys = availableKeys(facet)
	// Load default values from params
	if( params.has(keyName) ) {
		params.get(keyName).split(', ').map((k) => {
			if(allKeys.includes(k)) {
				defaultValue.push({ value: k, label: k })
			}
		})
	}
	const [selected, setSelected] = useState(defaultValue)


	// Handle change
	const handleSelected = (selected) => {
		const newParams = new URLSearchParams( params.toString())
		newParams.delete(keyName)

		if(selected.length) {
			newParams.set(keyName, selected.map( option => option.value ).join(', '))
		}

		setSelected(selected)
		handleParams(newParams)
	}

	const options = []    

	facet.buckets.map( (filter,i) => {
		// Cannot pass html to component, renders as string
		// options.push( { value: filter.key, label: `${filter.key} <span className="option-count">(${filter.doc_count})</span>` })
		options.push( { value: filter.key, label: filter.key})
	})

	useEffect(()=>{

		if( params.has(keyName) ) {
			const newValue = []
			const allKeys =  availableKeys(facet)
			let hasNonSelectableValue = false;
			params.get(keyName).split(', ').map((k) => {
				if( allKeys.includes(k) ) {
					newValue.push({ value: k, label: k })
				} else {
					hasNonSelectableValue = true
				}
			})
			if( hasNonSelectableValue ) {
				handleSelected(newValue)
				return;
			}

			if(selected !== newValue) {
				setSelected(newValue)
			}
		} else {
			setSelected([])
		}

	},[params,facet])

	
	// console.log({selected, defaultValue, params: params.toString()});
	return (
		<div className={ selected.length ? 'multiselect-container active' : 'multiselect-container'}>
			<label>{title}</label>
            <MultiSelect
                options={options}
                value={selected}
                onChange={handleSelected}
                labelledBy={title}
                disableSearch={true}
                hasSelectAll={false}
                overrideStrings={{
                    "selectSomeItems":"Välj " + title,
                    "allItemsAreSelected": "Alla är valda",
                    "selectAll": "Välj alla",
                    "search": "Sök"
                }}
            />
		</div>
	)
}

export default FacetGroup;